import ListSuratJalan from './ListSuratJalan'

export default ListSuratJalan
